module.exports = __webpack_public_path__ + "img/moustiquaire pour porte -fenêtre.dc3074be.jpg";